export default __webpack_public_path__ + "static/media/logo-white.eac9dd9b.png";